import { render, staticRenderFns } from "./ManterFaqView.vue?vue&type=template&id=06dcd64f"
import script from "./ManterFaqView.vue?vue&type=script&lang=js"
export * from "./ManterFaqView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports